//API keys
export var WorkPurchaseOrderKeys = {
    Paging: "workPurchaseOrderPagingData",
    WPOByJobcard: "workPurchaseOrderByJobcardNo",
    Status: "statusListWPOGet",
    WPOOrganizationModulesItemSetting: "WPOOrganizationModulesItemSetting",
    WPOList: "purchaseOrderListGet",
    Create: "",
    Update: "workPurchaseOrderUpdate",
    Get: "",
    PaymentTerm: "paymentTermPickList",
    PaymentMethod: "paymentMethodPickList",
    SupplierList: "supplierPickList",
    ShippingMethod: "shippingMethodPickList",
    ShippingTerm: "shippingTermPickList",
    Department: "departmentPickList",
    Warehouse: "wareHousePickList",
    Priority: "priorityPickList",
    PurchaseOrderList: "purchaseOrderList",
    ItemsPaging: "poItemsPagingAPI",
    Search: "searchPurchaseNo",
    PRGet: "purchaseOrderProcurementGet",
    PartDetail: "WorkPurchaseOrderPartDetailGet",
    OrganizationAddress: "OrganizationAddressPickListData",
    CreateWorkPurchaseOrder: "CreateWorkPurchaseOrderData",
    PartDetailsByProductId: 'getPartDetailsByProductId',
    PurchaseOrderById: "getWorkPurchaseOrderByIdData",
    POGet: "getWorkPurchaseOrder",
    Cancel: "cancelWorkPurchaseOrder",
    AttachmentSystemName: 'WorkPurchaseOrderAttachment',
    Upload: 'workPurchaseOrderUpload',
    attachmentList: "attachmentList"
};
